module.exports = "<div>\r\n    <img style=\"width : 100% ;height: 100vh;\" src=\"./assets/images/error_img.jpg\">\r\n</div>\r\n"